// 1. Reverted back to named export for Joyride v3+
import { Joyride, ACTIONS, EVENTS, STATUS } from "react-joyride";
import type { EventData } from "react-joyride";
import { useTourStore } from "@/tours";
import { TourTooltip } from "./TourTooltip";
import { TourBeacon } from "./TourBeacon";

export function TourManager() {
  const { tourState, stopTour, resetTour, setStepIndex } = useTourStore();

  const handleCallback = (data: EventData) => {
    const { action, index, status, type } = data;

    if (status === STATUS.FINISHED || status === STATUS.SKIPPED) {
      resetTour();
      return;
    }

    if (type === EVENTS.STEP_AFTER || type === EVENTS.TARGET_NOT_FOUND) {
      const lastIndex =
        tourState.steps.length > 0 ? tourState.steps.length - 1 : 0;
      const delta = action === ACTIONS.PREV ? -1 : 1;
      const nextIndex = Math.min(Math.max(index + delta, 0), lastIndex);
      setStepIndex(nextIndex);
    }

    if (action === ACTIONS.CLOSE) {
      stopTour();
    }
  };

  if (!tourState.tourId || tourState.steps.length === 0) {
    return null;
  }

  // 2. Inject step-level configurations to satisfy TypeScript
  const stepsWithConfig = tourState.steps.map((step) => ({
    ...step,
    showSkipButton: true,
    disableOverlayClose: true,
  }));

  return (
    <Joyride
      steps={stepsWithConfig}
      stepIndex={tourState.stepIndex}
      run={tourState.run}
      continuous
      scrollToFirstStep
      tooltipComponent={TourTooltip}
      beaconComponent={TourBeacon}
      onEvent={handleCallback}
      options={{ zIndex: 10001, overlayClickAction: false, buttons: ["back", "close", "primary", "skip"] }}
      styles={{
        overlay: {
          mixBlendMode: "normal",
        },
      }}
    />
  );
}